import React from 'react'
import HeaderOne from '../Components/Header/HeaderOne'
import Breadcrumb from '../Components/BreadCrumb/Breadcrumb'
import ServiceInner from '../Components/Services/ServiceInner'
import FooterFour from '../Components/Footer/FooterFour'
import ScrollToTop from '../Components/ScrollToTop'
import { usePageBanner } from '../hooks/usePageBanner'

function Service() {
    const { title, bgImage } = usePageBanner({
        pageSlug: 'services',
        fallbackTitle: 'Services',
    })

    return (
        <div>
            <HeaderOne />
            <Breadcrumb title={title} bgImage={bgImage} />
            <ServiceInner />
            <FooterFour />
            <ScrollToTop />
        </div>
    )
}

export default Service
